var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMinimize = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 12C13.5 12.5523 13.0523 13 12.5 13L5.5 13C4.94772 13 4.5 12.5523 4.5 12C4.5 11.4477 4.94772 11 5.5 11L11.5 11L11.5 5C11.5 4.44772 11.9477 4 12.5 4C13.0523 4 13.5 4.44772 13.5 5L13.5 12Z",
    fill: "#0D0F13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 20C19.5 19.4477 19.9477 19 20.5 19H27.5C28.0523 19 28.5 19.4477 28.5 20C28.5 20.5523 28.0523 21 27.5 21H21.5V27C21.5 27.5523 21.0523 28 20.5 28C19.9477 28 19.5 27.5523 19.5 27V20Z",
    fill: "#0D0F13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 13C19.9477 13 19.5 12.5523 19.5 12V5C19.5 4.44772 19.9477 4 20.5 4C21.0523 4 21.5 4.44772 21.5 5V11H27.5C28.0523 11 28.5 11.4477 28.5 12C28.5 12.5523 28.0523 13 27.5 13H20.5Z",
    fill: "#0D0F13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 19C13.0523 19 13.5 19.4477 13.5 20L13.5 27C13.5 27.5523 13.0523 28 12.5 28C11.9477 28 11.5 27.5523 11.5 27L11.5 21H5.5C4.94772 21 4.5 20.5523 4.5 20C4.5 19.4477 4.94772 19 5.5 19L12.5 19Z",
    fill: "#0D0F13"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMinimize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/minimize.2c1ccfc751d50fb8367f7aaad9666ba2.svg";